import React from 'react';
import Introduction from './steps/IntroductionStep'
import './style.css';
import importMapper from './mapping/importMapper';
import EditStep from './steps/EditStep';
import {Route} from 'react-router-dom';

export default class HrcsEditor extends React.PureComponent {

    static VERSION = 1;

    constructor(props) {
        super(props);
        this.state = HrcsEditor.getInitialState(this.loadDataFromLocalStorage());
    }

    render() {
        return <div>
            <Route path={this.props.match.url + '/'} exact={true} render={() => <Introduction onData={data => this.importData(data)} onError={ e => this.setState({error: e}) } canContinue={ this.state.rows.length > 0 } />}/>
            <Route path={this.props.match.url + '/2'} render={({history}) => <EditStep
                rows={this.state.rows}
                errorMessage={this.state.error}
                updateResearchActivity={(rowIndex, activityIndex, updatedActivity) => this.updateResearchActivity(rowIndex, activityIndex, updatedActivity)}
                updateHealthCategory={(rowIndex, categoryIndex, updatedCategory) => this.updateHealthCategory(rowIndex, categoryIndex, updatedCategory) }
                back={() => history.push('/editor/')}
                lastSaved={this.state.lastSaved}
            />}/>
        </div>
    }

    componentDidMount() {
        //this.timer = setInterval(() => HrcsEditor.saveDataToLocalStorage(this.state), 5000)
    }

    componentWillUnmount() {
        //HrcsEditor.saveDataToLocalStorage(this.state);
        //clearInterval(this.timer);
    }

    componentDidUpdate() {
        this.saveDataToLocalStorage(this.state)
    }

    updateResearchActivity(rowIndex, activityIndex, updatedActivity) {
        this.setState({
            rows: this.state.rows.map((row, i) => i === rowIndex ? {
                ...row,
                researchActivities: row.researchActivities.map((activity, j) => j === activityIndex ? {
                    ...activity,
                    value: updatedActivity.value ? parseInt(updatedActivity.value, 10) : 0,
                    percentage: updatedActivity.percentage ? parseInt(updatedActivity.percentage, 10) : 0
                } : activity)
            } : row)
        });
    }

    updateHealthCategory(rowIndex, categoryIndex, updatedActivity) {
        this.setState({
            rows: this.state.rows.map((row, i) => i === rowIndex ? {
                ...row,
                healthCategories: row.healthCategories.map((activity, j) => j === categoryIndex ? {
                    ...activity,
                    value: updatedActivity.value ? parseInt(updatedActivity.value, 10) : 0,
                    percentage: updatedActivity.percentage ? parseInt(updatedActivity.percentage, 10) : 0
                } : activity)
            } : row)
        });
    }

    importData(data) {
        this.setState({
            error: '',
            rows: importMapper(data)
        }, () => { this.props.history.push('/editor/2') });
    }

    saveDataToLocalStorage(data) {
        try {
            window.localStorage.setItem('app', JSON.stringify(data));
            const date = new Date();
            this.setState({
                lastSaved: `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')} kl. ${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}:${String(date.getSeconds()).padStart(2, '0')}`
            });
        } catch (e) {
            console.error('Kunne ikke lagre i localStorge:')
            console.error(e);
        }
    }

    loadDataFromLocalStorage() {
        const state = window.localStorage.getItem('app');
        if (state === null || state.version < 1) {
            return [];
        } else {
            return JSON.parse(state);
        }
    }

    static getInitialState(overrides = {}) {
        return Object.assign({
            step: 1,
            version: HrcsEditor.VERSION,
            rows: '',
            error: '',
            lastSaved: 'Aldri'
        }, overrides);
    }
}



// WEBPACK FOOTER //
// ./src/HrcsEditor/index.js